import FeatureFlagLink from './FeatureFlagLink'

export default FeatureFlagLink
